export const getDeckTypeChecks = (selectedCollection) => {
  const isDeck = selectedCollection?.type === 'DECK';
  const isMyCollection = selectedCollection?.type === 'COLLECTION';

  return {
    isDeck,
    isMyCollection,
    isCommander: isDeck && selectedCollection?.deck_type === 'COMMANDER',
    isOathbreaker: isDeck && selectedCollection?.deck_type === 'OATHBREAKER',
    isBrawl: isDeck &&
      (selectedCollection?.deck_type === 'BRAWL' || selectedCollection?.deck_type === 'STANDARD_BRAWL'),
  };
};
